import { certifications } from "../data";

export function Certifications() {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr] lg:items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-teal-600">
              Quality Assurance & Compliance
            </span>
            <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Certified to the world's highest standards
            </h2>
            <p className="mt-5 text-slate-500">
              Our quality assurance begins at raw-material procurement and
              extends through final commissioning. Every machine is built in
              accordance with international standards and independently audited
              for performance, safety, and environmental compliance.
            </p>
            <div className="mt-8 flex flex-wrap gap-4 text-sm text-slate-600">
              {["Documented traceability", "On-time delivery", "Lifecycle support"].map(
                (item) => (
                  <span key={item} className="inline-flex items-center gap-2">
                    <svg className="h-5 w-5 text-teal-500" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m5 13 4 4L19 7" />
                    </svg>
                    {item}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 sm:grid-cols-4">
            {certifications.map((c) => (
              <div
                key={c.code}
                className="group flex flex-col items-center rounded-lg border border-slate-100 bg-slate-50 p-6 text-center transition hover:-translate-y-1 hover:border-teal-200 hover:bg-white hover:shadow-xl hover:shadow-teal-900/5"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-md bg-gradient-to-br from-teal-600 to-cyan-500 text-white shadow-sm shadow-teal-600/30">
                  <svg className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2 4 5v6c0 5 3.5 8 8 11 4.5-3 8-6 8-11V5l-8-3Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="m9 12 2 2 4-4" />
                  </svg>
                </div>
                <div className="mt-4 text-base font-bold text-slate-900">
                  {c.code}
                </div>
                <div className="mt-1 text-xs text-slate-500">{c.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
